(($) => {
  $(document).ready(() => {
    const $customerExperience = $('.pricing-table-main-wrapper .pricing-table');
    if (!$customerExperience.length) return;

    const $pricingLists = $customerExperience.find('.pricing-table-wrapper');
    const $buttons = $customerExperience.find('.btn-compare-all-feature');
    
    $pricingLists.hide();

    $buttons.on('click', function (event) {
      event.preventDefault();
      const isVisible = $pricingLists.css('display') === 'flex';
      $pricingLists.css('display', isVisible ? 'none' : 'flex');
      
      $buttons.toggleClass('active', !isVisible);
    });
  });
})(jQuery);